import React, { Component } from "react";
import AddStaff from "../AddStaff/AddStaff";

class EditStaff extends Component {
  render() {
    return <AddStaff editStatus={true} staffId={this.props.match.params.id} />;
  }
}

export default EditStaff;
